import React, { useEffect, useState } from "react";
import ModalComponent from "../../../../../biblio/Modal/ModalComponent";
import { Col, Row } from "antd";
import SponsorResult from "../SponsorResult";
import Inputs from "../../../../../biblio/Inputs/Inputs";
import PrimaryButton from "../../../../../biblio/Buttons/PrimaryButton";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../../apis/store";
import MoyasarForm from "../../../../../components/Moyasar/MoyasarForm";
import { resetMoyasar, setRenewSponsorShip } from "../../../../../apis/slices/moyasarSlice";
interface Props {
  orphans: any;
  visible: boolean;
  setVisible: (visible: boolean) => void;
}
const RenewSponsorShip = ({ visible, setVisible, orphans }: Props) => {
  const dispatch = useDispatch<AppDispatch>();
  const { sponsorshipAmount } = useSelector(
    (state: RootState) => state?.sponsor
  );
  const [displayMoyasar, setDisplayMoyasar] = useState<boolean>(false);
  const [amount, setAmount] = useState(0);
  const [months, setMonths] = useState(0);

  const getSponsorshipAmount = (type: string) => {
    switch (type) {
      case "widow":
        return sponsorshipAmount?.widow_sponsorship_amount;
      case "main":
        return sponsorshipAmount?.main_sponsorship_amount;
      case "support":
        return sponsorshipAmount?.support_sponsorship_amount;
      case "main_support":
        return (
          sponsorshipAmount?.support_sponsorship_amount +
          sponsorshipAmount?.main_sponsorship_amount
        );

      default:
        return 0;
    }
  };

  useEffect(() => {
    const values: any[] = [];
    orphans?.forEach((el: any) => {
      values?.push({
        ...el,
        amount: getSponsorshipAmount(el?.sponsorship_type),
      });
    });
    const totalAmount = values?.reduce((a, b) => b.amount + a, 0);
    setAmount(months * totalAmount);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orphans, sponsorshipAmount, months]);

  const onMonthChange = (e: any) => {
    const newMounth =
      e.target.value === "" ? "" : Math.min(60, Math.max(1, e.target.value));
    setMonths(Number(newMounth));
  };
  const openMoyasar = () => {
    setDisplayMoyasar(true);
    dispatch(setRenewSponsorShip(months));
  };
  return (
    <>
      <ModalComponent
        title=""
        open={visible}
        onClose={() => {
          setVisible(false);
          dispatch(resetMoyasar());
          setAmount(0);
          setMonths(0);
        }}
        closeOnOutsideClick={true}
        width={600}
        modalStyle={{ top: 150 }}
      >
        <Row justify={"center"} style={{ width: "100%", marginBottom: "3rem" }}>
          <p className="takaful--confirm-logout">
            تجديد كفالة كل أيتامي و أراملي
          </p>
        </Row>
        <Row
          justify={"space-between"}
          style={{ width: "100%", marginBottom: "3rem", direction: "rtl" }}
        >
          <Col xxl={6} xl={6} lg={6} md={6} sm={7} xs={7}>
            <Inputs
              className="takaful--unsponsored-orphan-amount takaful--donation-input takaful--unsponsored-orphan-input takaful--renew-sponsorship-month"
              max={60}
              min={1}
              type="number"
              withArrow={true}
              value={months === 0 ? "" : months}
              placeholder="عدد الأشهر"
              onChange={(e) => onMonthChange(e)}
            />
          </Col>
          <Col xxl={12} xl={12} lg={12} md={12} sm={17} xs={17}>
            <SponsorResult
              className="takaful--renew-sponsorship"
              title=""
              items={[{ amount: amount }]}
            />
          </Col>
        </Row>
        {/* eslint-disable-next-line eqeqeq */}
        {amount != 0 && (
          <Row justify={"end"} dir="rtl" className="takaful--request-col-space">
            <Col xxl={4} xl={4} lg={6} md={6} sm={8} xs={8}>
              <PrimaryButton
                title="سداد"
                className="takaful--sponsor-orphan-card-button"
                onClick={() => openMoyasar()}
              />
            </Col>
          </Row>
        )}
      </ModalComponent>
      <MoyasarForm
        amount={amount}
        description="Takaful"
        open={displayMoyasar}
        handleClose={() => {
          setDisplayMoyasar(false);
          dispatch(resetMoyasar());
        }}
      />
    </>
  );
};

export default RenewSponsorShip;
